import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType, UserRegisterType } from "./types";

export type userType = {
  adm?: boolean;
  aprovador?: boolean;
  contato: string;
  email: string;
  empresa: string;
  foto?: string;
  gestorPA?: boolean;
  id: string;
  inspetorPA?: boolean;
  listaEquipes?: string[];
  matricula: string;
  nome: string;
  perfil: string;
  sendEmail?: boolean;
  status?: string;
  tags?: string[];
  assinatura?: string,
};

export type UserResponse = {
  users: [
    {
      contato: string;
      dataAlteracao: Date;
      dataCadastro: Date;
      email: string;
      empresa: string;
      foto: string;
      gerente: string;
      id: string;
      matricula: string;
      nome: string;
      notificacao: string;
      passwdReset: boolean;
      perfil: string;
      status: string;
      aliasname: string;
      tags: string[] | undefined;
      listaEquipes: string[] | undefined;
    }
  ];
};

export type UserRegisterResponse = {
  userFirebase: {
    dataAlteracao: number;
    email: string;
    empresa: string;
    passwordHash: string;
    passwordSalt: string;
    uid: string;
  };
  usuario: {
    contato: string;
    email: string;
    empresa: string;
    id: string;
    gerente: string;
    matricula: string;
    nome: string;
    perfil: string;
    aprovador: boolean;
    notificacao: string;
    status: string;
    dataCadastro: number;
  };
};

export type EditUserBodyType = {
  userToken: string;
  username: string;
  userEmpresa: string;
  userAlias: string;
  user: {
    gestorPA?: boolean;
    inspetorPA?: boolean;
    contato: string;
    empresa: string;
    foto: string;
    listaEquipes: string[] | [];
    matricula: string;
    nome: string;
    passwdReset: boolean;
    perfil: string;
    aprovador: boolean;
    notificacao: string;
    status: string;
    email: string;
    tags?: string[];
    id: string;
    listaEquipesNomes?: string[];
  };
};

export type EditSelfUserBodyType = {
  userToken: string;
  username: string;
  userEmpresa: string;
  usuario: string;
  email: string;
  nome: string;
  contato: string;
};

export type userTagsType = {
  id: string;
  nome: string;
};

class Users {


  getAllAprovadores = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/usuarios/getAllAprovadores", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        return error.response?.status;
      }
    }
  };

  getAllUsers = async (body: AuthBodyType) => {
    try {
      const data = await api.post("/usuarios/getAll", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.log("erro --->", error.response);
        console.error(error.message);
      }
    }
  };

  getUserById = async (body: AuthBodyType, id: string) => {
    try {
      const data = await api.post("/usuarios/getUserById", {
        ...body,
        id,
      });
      return data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.log("erro --->", error.response);
        console.error(error.message);
      }
    }
  };

  registerUser = async (body: AuthBodyType & UserRegisterType): Promise<UserRegisterResponse | undefined | number> => {
    try {
      const data = await api.post("/usuarios/newUser", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        error.response?.data as any;
        throw new Error(error.message);
      }
    }
  };

  changeUser = async (body: AuthBodyType, userAlias: string, user: userType) => {
    try {
      const data = await api.post("/usuarios/editUser", {
        ...body,
        userAlias,
        user,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        const dataError = error.response?.data as unknown as any;
        const erro = dataError.message;
        throw new Error(erro);
        // return error.response?.status;
      }
    }
  };

  changeSelfUser = async (body: EditSelfUserBodyType) => {
    try {
      const data = await api.post("/usuarios/editSelfUser", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  changeNotificacao = async (body: AuthBodyType, notificacao: string) => {
    try {
      const data = await api.post("/usuarios/changeNotificacao", {
        ...body,
        notificacao,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  deleteUser = async (body: AuthBodyType, user: string) => {
    try {
      const data = await api.post("/usuarios/deleteUser", {
        ...body,
        user,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  resetUserPassword = async (body: AuthBodyType, id: string) => {
    try {
      const data = await api.post("/usuarios/resetPassword", {
        ...body,
        id,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}
export default Users;
